import * as Sentry from '@sentry/react';

import { isAppError } from '@cenorion/api';

/**
 * Single seam for manual Sentry captures outside React's own boundary lifecycle: route
 * `errorElement`s, widget boundaries, and the query error policy funnel through here rather than
 * importing `@sentry/react` directly, so PII scrubbing (`sentry.ts`'s `beforeSend`) stays in one
 * place. `captureException` is a safe no-op with no active client.
 */
export function reportError(error: unknown, context?: Record<string, unknown>): void {
  const appError = isAppError(error) ? error : undefined;

  Sentry.captureException(error, {
    tags: appError ? { errorKind: appError.kind } : undefined,
    extra: { ...context, traceId: appError?.traceId },
  });
}
